import { PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';

import { useAutomatedPlanAccess } from '@/entities/user';
import { AppRoutes } from '@/shared/constants/app-routes.constant';

const AutomatedPlanElementComponent = ({ children }: PropsWithChildren) => {
	const automatedPlanAccess = useAutomatedPlanAccess();

	if (!automatedPlanAccess) {
		return <Navigate to={AppRoutes.Home} replace />;
	}

	return <>{children}</>;
};

export default AutomatedPlanElementComponent;
